export default {
    users: 10,
    consignee: 10,
    products: 10,
    pallets: 10,
    containers: 10,
    shippingCategory: 10,
    modal: 20,
};

export const pageSizeSearchAuto = 20;